import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import MapsUgcRoundedIcon from '@mui/icons-material/MapsUgcRounded';
import MarkEmailReadRoundedIcon from '@mui/icons-material/MarkEmailReadRounded';

import useMessageDialog from "../../store/messages";

import { mobile_headers, headers, filters, tabs } from "./config";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { markRead } from "./apiService";

import useSnackbarStore from "../../store/snackbar";

const MessageList = () => {

  const queryClient = useQueryClient();

  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);

  const { mutate, isPending } = useMutation({
    mutationFn: markRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["messages"] });
      queryClient.invalidateQueries({ queryKey: ["messages/threads"] });
      // showSnackbar('Updated successfully!', 'success');
    },
  })

  const showDialog = useMessageDialog((state) => state.showDialog);

  const additionalActions = [
    {
      tooltip: "Mark Thread as Read",
      Icon: MarkEmailReadRoundedIcon,
      onClick: (id, row) => mutate({customer_id: row?.customer_id, message_id: row?.message_id}),
      color: "success",
      // isLoading: (row) => loadingTickets[row?.repair_ticket_id],
      check: (row) => row?.is_unread,
    },
    {
      Icon: MapsUgcRoundedIcon,
      tooltip: "Message",
      onClick: (id, row) => {
        mutate({customer_id: row?.customer_id, message_id: row?.message_id});
        showDialog({ customer_id: row.customer_id, customer_name: row.customer_name, customer_phone: row.customer_phone })},
    },
  ];

  return (
    <Table tableId="messages/threads" title="Message" icon={InventoryRoundedIcon} headers={headers} mobile_headers={mobile_headers} filters={filters} defaultSort="-timestamp" idKey="message_id" fieldsToSearch={["Customer", "Customer Phone"]} edit={false} trash={false} view={false} additionalActions={additionalActions} createNew={false} tabs={tabs} tabField="message_type" defaultTab="conversation"
    clickAction = {(row) => {
        mutate({customer_id: row?.customer_id, message_id: row?.message_id});
        showDialog({ customer_id: row.customer_id, customer_name: row.customer_name, customer_phone: row.customer_phone })}}
    />
  );
};

export default MessageList;